import { Box, useMediaQuery } from "@mui/material";
import { theme } from "../styles/mui-theme";

export const BottomShadowAtom = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      {isMobile && (
        <Box
          component={"div"}
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            height: "200px",
            zIndex: 10,
            background:
              "linear-gradient(0deg, rgba(20, 20, 20, 1) 50%, rgba(20, 20, 20, 0) 100%)",
            pointerEvents: "none",
          }}
        />
      )}
    </>
  );
};
